import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, PropType } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import {
  ApplicantDetailQuery,
  Applicant,
  ArchiveApplicationMutation,
  ArchiveApplicationMutationMutation,
  RejectApplicationMutation,
  RejectApplicationMutationMutation,
  RejectApplicationMutationMutationVariables,
  ShortlistApplicantForAssessmentMutation,
  ShortlistApplicantForAssessmentMutationMutation,
  ShortlistApplicantForAssessmentMutationMutationVariables,
  ArchiveApplicationMutationMutationVariables,
  CandidateRejectionTypeEnum,
} from "@/gql"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { CandidateRejectionTypeEnumReasons } from "@/constants"
import ApplicantDetail from "./ApplicantDetail.vue"

type Action = "archive" | "shortlist" | null

type Form = {
  rejectionReason: CandidateRejectionTypeEnum
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationDetail',
  props: {
  applicant: {
    type: Object as PropType<Applicant>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()



const actionLoading = ref(false)
const showRejectDialog = ref(false)
const applicationAction = ref<Action>(null)

const form = ref<Form>({
  rejectionReason: CandidateRejectionTypeEnum.SeeYouLater,
})

const refetchQueries = computed(() => {
  return [
    {
      query: ApplicantDetailQuery,
      variables: {
        filter: {
          idIn: [props.applicant.scatterId],
        },
        per: 1,
      },
    },
  ]
})

const rejectApplication = async () => {
  if (!props.applicant) return
  actionLoading.value = true
  // Mutate
  const result = await mutate<
    RejectApplicationMutationMutation,
    RejectApplicationMutationMutationVariables
  >({
    mutation: RejectApplicationMutation,
    variables: {
      applicantId: props.applicant.prn,
      rejectionReason: form.value.rejectionReason,
    },
    handlePayloadErrors: true,
    refetchQueries: refetchQueries.value,
  })

  if (!result?.data?.rejectApplication?.error) {
    addSuccess("Application rejected successfully!")
  }
  actionLoading.value = false
}

const onApplicationAction = async (action: Action) => {
  if (!props.applicant) return
  const id = props.applicant.prn
  actionLoading.value = true

  switch (action) {
    case "shortlist":
      shortlistApplication(id)
      break

    case "archive":
      archiveApplication(id)
      break

    default:
      addError(`Unknown action ${action}`)
      break
  }
}

const shortlistApplication = async (applicantId: string) => {
  const result = await mutate<
    ShortlistApplicantForAssessmentMutationMutation,
    ShortlistApplicantForAssessmentMutationMutationVariables
  >({
    mutation: ShortlistApplicantForAssessmentMutation,
    variables: {
      id: applicantId,
    },
    handlePayloadErrors: true,
    refetchQueries: refetchQueries.value,
  })

  if (!result?.data?.shortlistApplicant?.error) {
    addSuccess("Application shortlisted successfully!")
    applicationAction.value = null
  }
  actionLoading.value = false
}

const archiveApplication = async (applicantId: string) => {
  const result = await mutate<
    ArchiveApplicationMutationMutation,
    ArchiveApplicationMutationMutationVariables
  >({
    mutation: ArchiveApplicationMutation,
    variables: {
      applicantId,
    },
    handlePayloadErrors: true,
    refetchQueries: refetchQueries.value,
  })

  if (!result?.data?.archiveApplication.error) {
    addSuccess("Application archived successfully!")
    applicationAction.value = null
  }
  actionLoading.value = false
}

const isEventAllowed = (event: string) => {
  return props.applicant?.allowedEvents?.includes(event)
}

return { __sfc: true,mutate, addSuccess, addError, props, actionLoading, showRejectDialog, applicationAction, form, refetchQueries, rejectApplication, onApplicationAction, shortlistApplication, archiveApplication, isEventAllowed, Icon, CandidateRejectionTypeEnumReasons, ApplicantDetail }
}

})